import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NgbCalendar, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Paging, DatoPaginadoModel } from 'src/app/shared/models/dato-paginado.model';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { ConfirmeValidators } from 'src/app/shared/directives/validators/confirme-validators';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { ArrendatarioEntry } from 'src/app/shared/entrys/arrendatario.entry';
import { RegistroCuentaService } from 'src/app/components/seguridad/containers/registrar/registro-cuenta.service';
import { ReasignacionSolicitudesService } from './reasignacion-solicitudes.service';
import { SolicitudModel } from 'src/app/shared/models/solicitud-model';
import { AlertsService } from 'src/app/shared/services/alerts.service';
import { EstablecimientoComercioService } from '../../../prestador/establecimiento-comercio/establecimiento-comercio.service';
import { CamaraComercioEntry } from 'src/app/shared/entrys/camara-comercio';
import { TipoSolicitudEntry } from 'src/app/shared/entrys/tipo-solicitud.entry';
import { AuthService } from 'src/app/shared/services/auth.service';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';

@Component({
	selector: 'app-reasignacion-solicitudes',
	templateUrl: './reasignacion-solicitudes.component.html',
	styleUrls: ['./reasignacion-solicitudes.component.scss']
})
export class ReasignacionSolicitudesComponent implements OnInit {
	dataTabla: DatoPaginadoModel;
	dataTabla2: DatoPaginadoModel;
	headersReasignacion: Array<string>;
	headersActuales: Array<string>;
	formSolicitudActual: FormGroup;
	formSolicitudReasignada: FormGroup;
	camarasLista: Array<CamaraComercioEntry>;
	tipoSolicitudLista: Array<TipoSolicitudEntry>;
	listaFuncionarios: Array<any>;
	listaFuncionariosReasignacion: Array<any>;

	funcionarioOrigenId: number;
	codigoCamara: string;
	solicitudId: string;
	funcionarioDestinoId: number;
	adminSuper = RolesUsuario.AdministradorSuper;
	// selectTipoRNT: ArrendatarioEntry;
	rnt: RNTPrestadorEntry;
	datoSolicitudSharedModel: DatoSolicitudSharedModel;
	paginaActual: number;
	userLogin: boolean;
	// dataVerificacion: {
	// 	tipo_rnt_id: string,
	// 	descripcion: string,
	// 	activo: string
	// };
	// fecha_inicio: any;
	// fecha_inicio_arredatario: any;

	constructor(
		private formBuilder: FormBuilder, public calendar: NgbCalendar,
		private dataSharedService: DataSharedService, private reasignacionSolicitudesService: ReasignacionSolicitudesService,
		private modalService: NgbModal, private alertsService: AlertsService,
		private establecimientoComercioService: EstablecimientoComercioService, public authService: AuthService) {
		this.dataTabla = {
			paging: {} as Paging,
		} as DatoPaginadoModel;
		this.dataTabla2 = {
			paging: {} as Paging,
		} as DatoPaginadoModel;
		this.dataTabla.items = [];
		this.dataTabla2.items = [];
		// this.dataSharedService.data$.subscribe(resultado => {
		// 	this.datoSolicitudSharedModel = resultado as DatoSolicitudSharedModel;
		// 	this.rnt = this.datoSolicitudSharedModel.data as RNTPrestadorEntry;
		// });
		this.formSolicitudActual = formBuilder.group({
			funcionario: [null],
			codigo_camara: [null, [Validators.required]],
			desc_camara: [null],
			radicado: [null],
			tipo_solicitud_id: [null]
		});
		this.formSolicitudReasignada = formBuilder.group({
			funcionario: [null, [Validators.required]],
		});
		this.paginaActual = 1;
		this.userLogin = authService.isToken();
	}

	ngOnInit() {
		this.establecimientoComercioService.getCamaras().subscribe(resultado => {
			if (resultado) {
				this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
				if (!this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
					this.formSolicitudActual.get('codigo_camara').patchValue(this.authService.getCamaraUser());
					this.formSolicitudActual.get('desc_camara').patchValue(this.camarasLista
						.find(x => x.codigo_camara === this.authService.getCamaraUser()).desc_camara);
				}
			}
		});
		this.reasignacionSolicitudesService.getTipoSolicitud()
			.subscribe(resultado => {
				if (resultado.result)
					this.tipoSolicitudLista = resultado.data as Array<TipoSolicitudEntry>;
			});
		if (!this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
			this.reasignacionSolicitudesService.getFuncionarios({ codigo_camara: this.authService.getCamaraUser(), es_destino: false })
				.subscribe(resultado => {
					if (resultado.result) {
						this.codigoCamara = this.authService.getCamaraUser();
						this.listaFuncionarios = resultado.data;
					}
				});
		}

		this.headersActuales = ['RNT', 'Abogado', 'Establecimiento', 'Radicado', 'Fecha de radicado', 'Tipo solicitud', 'Observaciones'];
		this.headersReasignacion = ['RNT', 'Abogado', 'Establecimiento', 'Radicado', 'Fecha de radicado', 'Tipo solicitud', 'Observaciones'];
	}

	onConsultarFuncionarios(codigo_camara: any) {
		this.listaFuncionariosReasignacion = [];
		this.formSolicitudActual.get('funcionario').reset();
		this.formSolicitudActual.get('radicado').reset();
		this.dataTabla2.items = [];
		this.dataTabla.items = [];
		if (codigo_camara) {
			this.reasignacionSolicitudesService.getFuncionarios({ codigo_camara: codigo_camara, es_destino: false })
				.subscribe(resultado => {
					if (resultado.result) {
						this.codigoCamara = codigo_camara;
						this.listaFuncionarios = resultado.data;
					}
				});
		}
	}

	onConsultarSolicitudes(page: number, funcionario: number, radicado: string, tipoSolicitudId: number) {
		this.reasignacionSolicitudesService.getSolicitudes(page, {
			codigo_camara: this.codigoCamara,
			funcionario_id: funcionario,
			lista_numero_radicacion: radicado,
			tipo_solicitud_id: tipoSolicitudId
		})
			.subscribe(resultado => {
				if (resultado.result) {
					this.dataTabla = resultado.data as DatoPaginadoModel;
					if (resultado.data.items) {
						this.dataTabla.items = resultado.data.items.map(map => {
							return { ...map, estado: false } as SolicitudModel;
						});
					}
				}
			});
	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.onConsultarSolicitudes(this.paginaActual, this.formSolicitudActual.get('funcionario').value,
			this.formSolicitudActual.get('radicado').value, this.formSolicitudActual.get('tipo_solicitud_id').value);
	}

	enviarForm() {
		this.funcionarioDestinoId = this.formSolicitudReasignada.get('funcionario').value;
		if (this.funcionarioDestinoId !== null && this.dataTabla2.items.length > 0) {
			this.solicitudId = '';
			this.dataTabla2.items.forEach(element => {
				this.solicitudId += (element.solicitud_id + ',');
			});
			this.reasignacionSolicitudesService.ReasignarFuncionario({
				codigo_camara: this.codigoCamara,
				lista_solicitudes: this.solicitudId,
				funcionario_id_destino: this.funcionarioDestinoId
			})
				.subscribe(resultado => {
					if (resultado.result) {
						// this.onConsultarSolicitudes(1, this.funcionarioOrigenId, this.formSolicitudActual.get('radicado').value);
						this.alertsService.success('Solicitudes reasignadas exitosamente', null, null);
					}
				});
		} else {
			this.alertsService.warn('No hay solicitudes por asignar', null, null);
		}
		this.formSolicitudReasignada.reset();
		this.dataTabla2.items = [];
		this.formSolicitudActual.reset();
		this.dataTabla.items = [];
		this.listaFuncionariosReasignacion = [];
		this.listaFuncionarios = [];
		if (!this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
			this.formSolicitudActual.get('codigo_camara').patchValue(this.authService.getCamaraUser());
			this.formSolicitudActual.get('desc_camara').patchValue(this.camarasLista
				.find(x => x.codigo_camara === this.authService.getCamaraUser()).desc_camara);
			this.reasignacionSolicitudesService.getFuncionarios({ codigo_camara: this.authService.getCamaraUser(), es_destino: false })
				.subscribe(resultado => {
					if (resultado.result) {
						this.codigoCamara = this.authService.getCamaraUser();
						this.listaFuncionarios = resultado.data;
					}
				});
		}
	}

	filtrar() {
		this.onConsultarSolicitudes(1, this.formSolicitudActual.get('funcionario').value,
			this.formSolicitudActual.get('radicado').value, this.formSolicitudActual.get('tipo_solicitud_id').value);
		this.reasignacionSolicitudesService.getFuncionarios({ codigo_camara: this.codigoCamara, es_destino: true })
			.subscribe(resultado => {
				if (resultado.result) {
					this.listaFuncionariosReasignacion = resultado.data;
				}
			});
	}


	// funcionalidad pasar
	seleccionarActual(solicitud_id: Array<any>) {
		const index = this.dataTabla.items.map(function (e) { return e.solicitud_id; }).indexOf(solicitud_id);
		this.dataTabla.items[index].estado = !this.dataTabla.items[index].estado;
	}

	seleccionarReasignado(solicitud_id: Array<any>) {
		const index = this.dataTabla2.items.map(function (e) { return e.solicitud_id; }).indexOf(solicitud_id);
		this.dataTabla2.items[index].estado = !this.dataTabla2.items[index].estado;
	}

	enviarSeleccionados() {
		const arrayIndex: Array<any> = [];
		this.dataTabla.items.forEach(element => {
			if (element.estado) {
				element.estado = false;
				arrayIndex.push(element);
				this.dataTabla2.items.push(element);
			}
		});
		arrayIndex.forEach(element => {
			const index = this.dataTabla.items.map(function (e) { return e.name; }).indexOf(element.name);
			this.dataTabla.items.splice(index, 1);
		});
	}

	devolverSeleccionados() {
		const arrayIndex: Array<any> = [];
		this.dataTabla2.items.forEach(element => {
			if (element.estado) {
				element.estado = false;
				arrayIndex.push(element);
				this.dataTabla.items.push(element);
			}
		});
		arrayIndex.forEach(element => {
			const index = this.dataTabla2.items.map(function (e) { return e.name; }).indexOf(element.name);
			this.dataTabla2.items.splice(index, 1);
		});
	}

	enviarTodo() {
		const arrayIndex: Array<any> = [];
		this.dataTabla.items.forEach(element => {
			element.estado = false;
			arrayIndex.push(element);
			this.dataTabla2.items.push(element);
		});
		arrayIndex.forEach(element => {
			const index = this.dataTabla.items.map(function (e) { return e.name; }).indexOf(element.name);
			this.dataTabla.items.splice(index, 1);
		});
	}

	devolverTodo() {
		const arrayIndex: Array<any> = [];
		this.dataTabla2.items.forEach(element => {
			element.estado = false;
			arrayIndex.push(element);
			this.dataTabla.items.push(element);
		});
		arrayIndex.forEach(element => {
			const index = this.dataTabla2.items.map(function (e) { return e.name; }).indexOf(element.name);
			this.dataTabla2.items.splice(index, 1);
		});
	}

}
